<template>
  <!-- 病历打印 -->
  <div class="medicalRecordPrint1" :class="{ medicalRecordPrint1_show: !autoPrint }">
    <div ref="print4" class="medicalRecordPrint1_body" v-if="recordsData.patientName">
      <div class="mk_title">病历记录</div>
      <div class="hander">
        <div class="u_row">
          <div class="u_item">
            <span class="label">就诊日期:</span>
            <span class="value">{{ recordsData.visitDateTime }}</span>
          </div>
          <div class="u_item">
            <span class="label"></span>
            <span class="value"></span>
          </div>
          <div class="u_item">
            <span class="label checkbox_1">
              <i :class="{ check: cz }"></i>初诊
              <span class="fgx">/</span>
              <i :class="{ check: fz }"></i>复诊
            </span>
          </div>
        </div>
        <div class="u_row">
          <div class="u_item">
            <span class="label">姓名:</span>
            <span class="value">{{ recordsData.patientName }}</span>
          </div>
          <div class="u_item">
            <span class="label">性别:</span>
            <span class="value">{{ recordsData.gender }}</span>
          </div>
          <div class="u_item">
            <span class="label">年龄:</span>
            <span class="value" v-if="recordsData.patientAge">{{ recordsData.patientAge }}岁</span>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="u_row">
          <div class="u_item">
            <span class="label">主诉:</span>
            <span class="value">
              <span>{{ recordsData.chiefComplaintDegree }}</span>
              <span>{{ recordsData.diagnosticName1 }}</span>
              <span>{{ recordsData.chiefComplaintTime }}</span>
              <span v-if="recordsData.chiefComplaintTime">{{
                recordsData.chiefComplaintTimeType
              }}</span>
            </span>
          </div>
          <div class="u_item">
            <span class="label">中医诊断:</span>
            <span class="value">{{ recordsData.diagnosticName2 }}</span>
          </div>
        </div>
        <div class="u_row">
          <div class="u_item">
            <span class="label">既往史:</span>
            <span class="value">{{
              patientBaseInfo.pastHistory &&
                patientBaseInfo.pastHistory.trim() != "无"
                ? patientBaseInfo.pastHistory
                : "健康"
            }}</span>
          </div>
          <div class="u_item">
            <span class="label">过敏史:</span>
            <span class="value">{{
              patientBaseInfo.allergyHistory || "无"
            }}</span>
          </div>
        </div>
        <template v-if="patientBaseInfo.genderName == '女'">
          <div class="u_row">
            <div class="u_item">
              <span class="label">节育史:</span>
              <span class="value">{{
                patientBaseInfo.birthControlHistory || "无"
              }}</span>
            </div>
            <div class="u_item">
              <span class="label">生育史:</span>
              <span class="value">{{
                patientBaseInfo.birthHistory || "无"
              }}</span>
            </div>
          </div>
          <div class="u_row">
            <div class="u_item">
              <span class="label">家族史:</span>
              <span class="value">{{
                patientBaseInfo.familyHistory || "无"
              }}</span>
            </div>
          </div>
        </template>
        <div class="u_row" v-else>
          <div class="u_item">
            <span class="label">节育史:</span>
            <span class="value">{{
              patientBaseInfo.birthControlHistory || "无"
            }}</span>
          </div>
          <div class="u_item">
            <span class="label">家族史:</span>
            <span class="value">{{
              patientBaseInfo.familyHistory || "无"
            }}</span>
          </div>
        </div>

        <div class="u_row">
          <div class="u_item">
            <span class="label">中医四诊:</span>
            <span class="value">
              <symptomChanges v-for="(item, index) in dsName2" :key="index" :symptomInfo="item" isPrint :isEnd="index == dsName2.length - 1">{{ item.dsName }}</symptomChanges>
              <div>{{ dsName }}</div>
            </span>
          </div>
        </div>
        <div class="u_row cf">
          <div class="u_item">
            <div class="label">处方:</div>
            <div class="value">
              <drugsFormat :list="drugList" :size="3"></drugsFormat>
              <span v-if="quantity" class="quantity">x{{ quantity }}</span>
            </div>
          </div>
        </div>
        <div class="u_row">
          <div class="u_item">
            <div class="label">医嘱禁忌:</div>
            <span class="value" v-html="r2br()"></span>
          </div>
        </div>
        <div class="ct">
          <courseTreatment v-if="info.diagnosticId2" :diseaseId="info.diagnosticId2" :patientCode="info.patientCode" />
          <span class="cureNumber" v-if="cureNumber">治愈:{{ cureNumber }}人</span>
        </div>
      </div>
      <div class="foot">
        <div class="u_row">
          <div class="u_item">
            <span class="label">医师:</span>
            <span class="value">{{ userInfo.doctorName }}</span>
          </div>
          <div class="u_item">
            <span class="label">医师签名(签章):</span>
            <span class="value"></span>
          </div>
        </div>
      </div>
    </div>
    <Spin v-if="indexSpin.show && isSpin" fix>
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import request from "@/utils/request";
export default {
  props: {
    info: {
      type: Object,
      default: function () {
        return {};
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    taboo: {
      type: String,
      default: "",
    },
    drugList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 是否显视加载遮罩
    isSpin: {
      type: Boolean,
      default: false,
    },
    quantity: {
      type: String | Number,
      default: "",
    },
    // 是否自动打印
    autoPrint: {
      type: Boolean,
      default: true,
    },
    // 是否打印通用医嘱
    generalMedicalOrders: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.init();
    },
  },
  computed: {
    ...mapGetters(["userInfo", "bnf", "indexSpin", "GENERAL_DOCTOR_ADVICE"]),
    fourChineseMedicine() {
      let arr = [this.common.trim(this.recordsData.fourChineseMedicine)];
      if (this.recordsData.chiefComplaint)
        arr.push(this.recordsData.chiefComplaint);
      return arr.join(",");
    },
    dsName() {
      let menstruationLastTime = "";
      if (
        this.recordsData.gender == "女" &&
        this.recordsData.menstruationLastTime
      ) {
        menstruationLastTime = ` 末次月经${this.recordsData.menstruationLastTime}`;
      }
      return (this.recordsData.chiefComplaint || "") + menstruationLastTime;
    },
    dsName2() {
      return this.recordsData.symptomInfoList || [];
    },
    dsIds() {
      return this.recordsData.symptomInfoList.map((i) => i.dsId);
    },
    cz() {
      return this.czIds.some((i) => {
        return this.dsIds.includes(i);
      });
    },
    fz() {
      if (this.cz) return false;
      return this.fzIds.some((i) => {
        return this.dsIds.includes(i);
      });
    },
  },
  data() {
    return {
      // 30417初诊 30216病情好转 30234病情同前 30505前病已愈
      cureNumber: 0,
      czIds: [30417, 30505], //初诊
      fzIds: [30216, 30234], //复诊
      showWin: true,
      recordsData: { symptomInfoList: [] },
      loading: false,
      patientBaseInfo: {
        allergyHistory: "", //	过敏史
        birthControlHistory: "", //	节育史
        birthHistory: "", //	生育史
        familyHistory: "", //	家族史
        pastHistory: "", //	既往史
        genderName: "",
      },
    };
  },
  methods: {
    getCureNumberByDiseaseId() {
      if (this.info.diagnosticId2) {
        let obj = {
          diagnosticid2: this.info.diagnosticId2 * 1,
        };
        this.api2("getCureNumberByDiseaseId", obj).then((res) => {
          this.cureNumber = res.result.cureNumber;
        });
      } else {
        this.cureNumber = 0;
      }
    },
    r2br() {
      if (this.taboo) {
        return this.taboo;
      } else {
        let str = "";
        if (this.generalMedicalOrders) {
          str = this.GENERAL_DOCTOR_ADVICE.join(" ");
        }
        let taboo =
          str +
          (this.recordsData.drugTaboo || "") +
          (this.recordsData.doctorsAdvice || "");
        return taboo ? this.common.tabooFormat(taboo) : "";
      }
    },
    async getData() {
      if (!(this.info && this.info.patientCode)) return;
      let obj = {
        patientCode: this.info.patientCode, // 患者编码
        prescriptionNo: this.info.prescriptionNo, // 处方号

        isSettlement: this.info.isSettlement || 0, // 结算类型--是否结算 0.未结算(智互查询，通过处方号和患者编码查询)  1.已结算(HIS查询，通过就诊时间和患者编码查询)
        visitDate: this.info.visitDate
          ? this.common.parseTime(this.info.visitDate, "{y}-{m}-{d}")
          : "", // 就诊时间

        state: /index/.test(this.$route.fullPath) ? 1 : 0, // 0 开方未结束  state=1 开方已结束 首页
      };

      try {
        await this.getPatientBaseInfo();
      } catch (error) {
        console.log(error);
      }

      this.loading = true;
      this.$store.commit("openSpin");
      this.api2("getPrintMedicalRecordsData", obj)
        .then((res) => {
          this.$store.commit("closeSpin");
          this.loading = false;
          if (res.result.length) {
            this.recordsData = res.result[0];
            setTimeout(() => {
              if (this.autoPrint) {
                this.$print(this.$refs.print4);
                this.close();
              }
            }, 300);

            // 记录日志用
            res.drugList = this.drugList;
            this.$store.commit("sendLog", {
              patientCode: obj.patientCode,
              apiName: "getPrintMedicalRecordsData",
              inParams: obj,
              outParams: res,
              remarks: `病历打印数据获取成功 处方ID:${obj.prescriptionNo} `,
            });
          } else {
            this.$Message.warning("病历打印数据获取失败");
            this.recordsData = { symptomInfoList: [] };
            this.close();
          }
          this.recordsData.taboo = this.r2br();
          this.$emit("getDataSuccess", this.recordsData);
        })
        .catch((err) => {
          this.loading = false;
          this.recordsData = { symptomInfoList: [] };
          this.close();
        });
    },
    // 回填各史
    getPatientBaseInfo() {
      return new Promise((resolve, reject) => {
        request
          .post("/hzda/getPatientBaseInfo", {
            patientCode: this.info.patientCode,
          })
          .then((res) => {
            Object.assign(this.patientBaseInfo, res.result);
            resolve(res.result);
          })
          .catch(reject);
      });
    },
    close() {
      this.$emit("input", false);
    },
    init() {
      this.recordsData = { symptomInfoList: [] };
      if (this.value) {
        this.getData();
        this.getCureNumberByDiseaseId();
      }
    },
    print() {
      this.$print(this.$refs.print4);
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss">
.medicalRecordPrint1_body {
  width: 100%;
  color: #000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background: #fff;
  display: none;
  font-size: 13px;

  .ivu-badge {
    margin: 0 10px 0 0;

    .ivu-badge-body {
      top: -12px !important;
    }

    .ivu-badge-count {
      border-color: #ddd;
    }
  }

  .drugDecoctPattern,
  .drugTakePattern {
    display: none;
  }

  .quantity {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 22px;
    color: #f00;
  }

  .drugs_format {
    font-size: 13px !important;
    line-height: 1.5em !important;
    width: 100%;

    .drug {
      flex: 1;
      white-space: nowrap;
      display: inline-block;
    }
  }

  .hander {
    border-bottom: 1px dotted #b20000;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .checkbox_1 {
    display: flex;
    align-items: center;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .fgx {
      padding: 0 10px;
    }

    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 1px solid #b20000;
      margin-right: 2px;
      position: relative;

      &.check::after {
        content: " ";
        display: inline-block;
        border: 2px solid #b20000;
        border-width: 0 0 2px 2px;
        width: 10px;
        height: 6px;
        transform: rotate(-40deg);
        position: absolute;
        top: 3px;
        left: 2px;
      }
    }
  }

  .mk_title {
    line-height: 40px;
    font-size: 26px;
    text-align: center;
    color: #b20000;
    font-family: 隶书;
  }

  .u_row {
    line-height: 1.5em;
    display: flex;
    justify-content: space-between;
    width: 100%;

    .u_item {
      display: flex;

      .label {
        color: #b20000;
        padding-right: 2px;
      }
    }
  }

  .content {
    min-height: 520px;

    .u_row {
      line-height: 1.5em;
    }

    .label {
      width: 64px;
      flex-shrink: 0;
      text-align: right;
    }

    .cf {

      .value,
      .u_item {
        width: 100%;
        position: relative;
      }
    }
  }

  .foot {
    border-top: 1px dotted #b20000;
    padding-bottom: 10px;

    .value {
      width: 120px;
    }
  }

  .drugs_format {
    font-size: 13px;
    line-height: 1.5em;
  }
}

.medicalRecordPrint1_show .medicalRecordPrint1_body {
  display: block;
  position: relative;
  background: transparent;
}

.ct {
  padding-top: 10px;

  .cureNumber {
    background: #ffd1b1;
    border-radius: 3px;
    font-size: 12px;
    line-height: 16px;
    padding: 4px 8px;
    margin-left: 8px;
  }
}

@media print {
  .medicalRecordPrint1_body {
    display: block;
    position: absolute;
  }

  .ct {
    display: none;
  }
}
</style>